export default class ColorRandom {
  private static count = 0;

  private static colors: string[] = [
    '#130924',
    '#3F0C29',
    '#5A1329',
    '#8F1C2C',
  ]

  public static get(): string {
    const color = this.colors[this.count];
    this.count = this.count + 1;
    if (this.count === this.colors.length) {
      this.count = 0;
    }
    return color;
  }
}
